module.exports = __webpack_public_path__ + "img/removeandslot.db78bc3e.png";